const ListType = {
    startList: 0,
    raceResultList: 1,
    overallResultList: 2,
    resultList: 3
};

export default ListType;